import { useQuery } from '@tanstack/react-query';
import type { CalendarEvent } from 'src/meetings/models';

type UseEventResult = {
  event: CalendarEvent | null;
  isLoading: boolean;
  error: unknown;
};

export const useEvent = (eventId: string): UseEventResult => {
  const { data, isLoading, error } = useQuery<CalendarEvent>({
    queryKey: ['calendar-events', eventId],
  });

  return {
    event: data || null,
    isLoading,
    error,
  };
};
